export enum ListStyle {
    Grid = 'grid',
    Kanban = 'kanban',
    List = 'list',
}
